import hexToRgb from 'services/hexToRGB';

export const rgbaFromHexAndOpacity = (hex: string, opacity: number) => {
  const { r, g, b } = hexToRgb(hex);

  const _0_100_ = opacity < 0 ? 0 : opacity > 100 ? 100 : opacity;

  return `rgba(${r}, ${g}, ${b}, ${_0_100_ * 0.01})`;
};
